import { Typography } from "@mui/material";
import React, { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/TypeScript/hooks";
import { useHasAuthorization } from "../../hooks/TypeScript/useHasAuthorization";
import { getProjectRequests } from "../../redux/slices/projects";
import { selectUserOrImpersonation } from "../../redux/slices/ui";
import { isNullOrUndefined } from "../../utils/generalHelpers";
import { MatchType, Role } from "../Guards";

const TooltipTypography = React.forwardRef(function TooltipTypography(
  props,
  ref: React.ForwardedRef<HTMLSpanElement>
) {
  const impersonation = useAppSelector(selectUserOrImpersonation);
  const userIsInAdmin = useHasAuthorization({
    roles: [Role.Admin],
    matchType: MatchType.Single,
  });
  const projectRequestNumbers = useAppSelector(
    (x) =>
      x.projects.projectRequests?.filter((a) => {
        return (
          a.requestedBy === impersonation.personId ||
          impersonation.personId === 0 ||
          userIsInAdmin
        );
      }).length
  );
  return (
    <>
      {projectRequestNumbers < 1 ? (
        <>0</>
      ) : (
        <Typography
          {...props}
          ref={ref}
          variant="body1"
          children={projectRequestNumbers}
        />
      )}
    </>
  );
});

export function ProjectRequestCountBadge() {
  const dispatch = useAppDispatch();

  const impersonation = useAppSelector(selectUserOrImpersonation);

  const impersonationId = useMemo(
    () => impersonation.personId,
    [impersonation]
  );
  useEffect(() => {
    if (!isNullOrUndefined(impersonationId)) {
      dispatch(getProjectRequests());
    }
  }, [dispatch, impersonationId]);

  return <TooltipTypography />;
}
